import { useState, useEffect } from 'react';
import { fetchClientApplications } from '../../../services/api';

const useClientApplications = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadClientApplications = async () => {
      try {
        setLoading(true);
        const data = await fetchClientApplications();
        setJobs(Array.isArray(data) ? data.filter(Boolean) : []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadClientApplications();
  }, []);

  return { jobs, loading, error };
};

export default useClientApplications;
